module.exports = "<div class=\"progress-bar-container\">\r\n  <div\r\n    class=\"progress-bar\"\r\n    [style.width]=\"params.value === 100 ? '100%' : params.value + '%'\"\r\n  >\r\n    <strong>{{ params.value }}%</strong>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/progress-bar-cell/progress-bar-cell.component.html
// module id = 2335
// module chunks = 66